"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AuthenticatedPlayer = exports.SessionUser = exports.Roles = void 0;
require("firebase/compat/auth");
// copied from api - lib/roles.ts
// TODO: put Roles in a rafflebox-lib
var Roles;
(function (Roles) {
    Roles["RB_ADMIN"] = "RB Admin";
    Roles["TICKET_SELLER"] = "Ticket Seller";
    Roles["RAFFLE_ADMIN"] = "Raffle Admin";
    Roles["TICKET_DRAWER"] = "Ticket Drawer";
    Roles["GOLDRUSH_TICKET_SELLER"] = "Goldrush Ticket Seller";
    Roles["GOLDRUSH_ADMIN"] = "Goldrush Admin";
    Roles["ACCOUNT_OWNER"] = "Account Owner";
    Roles["RB_FINANCE"] = "Rafflebox Finance";
    Roles["INVOICE_VALIDATOR"] = "Invoice Validator";
    Roles["INVOICE_AUTHORIZER"] = "Invoice Authorizer";
    Roles["RB_SALES"] = "Rafflebox Sales";
})(Roles = exports.Roles || (exports.Roles = {}));
/**
 * Represents the signed in User.
 */
class SessionUser {
    constructor(idTokenResult) {
        this.hasRole = (roles) => {
            // convert authRoles to array if it is not
            const validRoles = Array.isArray(roles) ? roles : [roles];
            if (this.roles.find((role) => validRoles.includes(role))) {
                return true;
            }
            return false;
        };
        this.id = idTokenResult.claims.user_id;
        this.organizationId = idTokenResult.claims.organizationId;
        this.organizationUuid = idTokenResult.claims.organizationUuid;
        this.organizationName = idTokenResult.claims.organizationName;
        this.email = idTokenResult.claims.email;
        this.username = idTokenResult.claims.username;
        this.name = idTokenResult.claims.name;
        this.roles = idTokenResult.claims.roles;
        this.permissions = idTokenResult.claims.permissions;
        this.organizationIds = idTokenResult.claims.organizationIds;
    }
}
exports.SessionUser = SessionUser;
class AuthenticatedPlayer {
    constructor(idTokenResult) {
        this.id = idTokenResult.claims.id;
        this.email = idTokenResult.claims.email;
        this.name = idTokenResult.claims.name;
    }
}
exports.AuthenticatedPlayer = AuthenticatedPlayer;
//# sourceMappingURL=data:application/json;base64,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